import React, { Component } from 'react';
import {setPianoRollCursor} from 'actions/index.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Track from 'track/Track.js';
import Notes from 'midi/Notes.js';
import { connect } from "react-redux";
import Resolution from 'engine/Resolution.js';

const WIDTH = 36;
const PianoRollTimeGridStep = (props) => {
    let className = '';
    
    let modNum = props.resolution.isTriplet ? 3 : 4;
    let modNum2 = props.resolution.isTriplet ? 12.0 : 16.0;
    if (props.xScale < 0.8) {
        modNum *= 2;
    }
    
    if (props.stepNumber % modNum === 0) {
        className += ' bar';
    }
    let style = {
        width: WIDTH * props.xScale,
        minWidth: WIDTH * props.xScale,
        height: props.height,
    };
    
    
    if (Math.floor(props.stepNumber / modNum) % 2 == 1) {
        className += ' odd';
    }
    if (props.xScale < 0.8) {
        if (props.stepNumber % 2 === 1) {
            style.borderStyle = 'none';
        }
    }
    
    return (
        <div
         style={style}
          className={className + ' time-grid-step'}>
          <div
            onClick={() => {
                props.sequencerEngine.cursor.setStep(props.stepNumber, props.resolution);
                props.setPianoRollCursor(props.stepNumber);
            }}
            className="time-grid-top">
            <ConditionedComponent condition={props.stepNumber % modNum === 0}>
              {props.stepNumber % modNum  === 0 ? (props.stepNumber / modNum2) + 1 : ''}
            </ConditionedComponent>
          </div>
        </div>
    );
}
const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    return {
        resolution: resolution
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setPianoRollCursor: (cursor) => dispatch(setPianoRollCursor(cursor)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollTimeGridStep);
